import moment from 'moment'

import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/es'
import 'moment/locale/it'
import 'moment/locale/nl'
import 'moment/locale/nb'

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
